import React from 'react';
import logo from '../assets/logoUnion.png';
import '../css/navBar.css';

function NavBarLogin() {


    return (
        <>
            <nav id="navBar" class="navbar navbar-expand-lg py-5 navbarLoginMobile">
                <div class="container">
                    <a class="navbar-brand" href='/' >
                        <img src={logo} alt="" />
                    </a>
                </div>
            </nav>
        </>
    );
}


export default NavBarLogin;